import { AcquirerType } from 'types';
import AddNewBlockButton from './components/AddNewBlockButton';
import { BankSettingFields } from './components/BankSettingFields/BankSettingFields';
import { BankSettingsContext, IBankSettingsContext } from '../../../bankSettingsState/bankSettingsContext';
import React, { useContext } from 'react';
import style from './BankSettingsBlock.module.scss';

const BankSettingsBlock: React.FC = () => {
	const {
		changePriority,
		changeMerchantId,
		changeMerchantName,
		changeSbpLogin,
		changeSbpAccountNumber,
		changeAcquirer,
		changeYandexApiKey,
		changeYandexPaymentType,
		changeVivaApiKey,
		changeVivaApiSecret,
		changeAccNumber,
		changeSector,
		changeSdRef,
		changeYandexChequeApiToken,
		changeYandexChequeApiPartnerId,
		changeMerchantAccount,
		changeStore,
		changeXApiKey,
		changeCheckoutUrlPrefix,
		toggleSplitPayments3S,
		changeMerchantBalanceAccountId,
		changeKmBalanceAccountId,
		toggleDisplayTips,
		toggleIsFeeFiscalized,
		toggleGenerateQrInstantly,
		changePaymentTypeId,
		changeSmsCode,
		changeTBankPlaceId,
		changeMasterWallet,
		setFetchedAcquirers,
		setBankSettingsFile,
		setLogoFile,
		addBankSettingBlock,
		deleteBankSettingBlock,
		deleteBankSettingFile,
		changeTypeOfModalWindow,
		fetchedAcquirers,
		bankSettings,
	} = useContext<IBankSettingsContext>(BankSettingsContext);

	const activeQrSettingsId = bankSettings.find(
		(el) => el.acquirer?.type === AcquirerType.QR && el.generateQrInstantly,
	)?.id;

	return (
		<div className={style.container}>
			{bankSettings.length ? (
				bankSettings.map((el) => (
					<BankSettingFields
						key={el.id}
						settingsId={el.id}
						acquirerId={el.acquirer?.id}
						bankSettingsFilePath={el.paymentTemplateFilePath}
						logoFilePath={el.logoPath}
						selectedYandexPaymentTypes={el.yandexPaymentTypes || []}
						acquirerType={el.acquirer?.type}
						isTipsSupported={el.isTipsSupported}
						generateQrInstantly={el.generateQrInstantly}
						isGenerateQrInstantlyDisabled={!!activeQrSettingsId && el.id !== activeQrSettingsId}
						isFeeFiscalized={el.isFeeFiscalized}
						splitPayments3S={!!el.adyen?.splitPayments3S}
						fetchedAcquirers={fetchedAcquirers}
						changeAcquirer={changeAcquirer}
						setFetchedAcquirers={setFetchedAcquirers}
						changeMerchantId={changeMerchantId}
						changeMerchantName={changeMerchantName}
						changePriority={changePriority}
						changeSbpLogin={changeSbpLogin}
						changeSbpAccountNumber={changeSbpAccountNumber}
						changeYandexPaymentType={changeYandexPaymentType}
						changeYandexApiKey={changeYandexApiKey}
						changeVivaApiKey={changeVivaApiKey}
						changeVivaApiSecret={changeVivaApiSecret}
						changeAccNumber={changeAccNumber}
						changeSector={changeSector}
						changeSdRef={changeSdRef}
						changeYandexChequeApiToken={changeYandexChequeApiToken}
						changeYandexChequeApiPartnerId={changeYandexChequeApiPartnerId}
						changeMerchantAccount={changeMerchantAccount}
						changeStore={changeStore}
						changeXApiKey={changeXApiKey}
						changeCheckoutUrlPrefix={changeCheckoutUrlPrefix}
						toggleSplitPayments3S={toggleSplitPayments3S}
						changeMerchantBalanceAccountId={changeMerchantBalanceAccountId}
						changeKmBalanceAccountId={changeKmBalanceAccountId}
						setBankSettingFile={setBankSettingsFile}
						setLogoFile={setLogoFile}
						deleteBankSettingBlock={deleteBankSettingBlock}
						deleteBankSettingFile={deleteBankSettingFile}
						toggleDisplayTips={toggleDisplayTips}
						toggleIsFeeFiscalized={toggleIsFeeFiscalized}
						toggleGenerateQrInstantly={toggleGenerateQrInstantly}
						changePaymentTypeId={changePaymentTypeId}
						changeSmsCode={changeSmsCode}
						changeTBankPlaceId={changeTBankPlaceId}
						changeMasterWallet={changeMasterWallet}
						changeTypeOfModalWindow={changeTypeOfModalWindow}
					/>
				))
			) : (
				<div className={style.divider} />
			)}
			<AddNewBlockButton addBankSettingsBlock={addBankSettingBlock} />
		</div>
	);
};

export default React.memo(BankSettingsBlock);
